export type {
  TransactionType,
  Category,
  Transaction,
  TransactionsResponse,
  CategoryBreakdown,
  Report,
  TransactionFilters,
  CreateCategoryData,
  UpdateCategoryData,
  CreateTransactionData,
  UpdateTransactionData,
  BatchUpdateTransactionPatch,
  BudgetGoal,
  BudgetGoalsResponse,
  BudgetLine,
  BudgetSummary,
} from './types';
export * from './errors';
export type { ParsedTransactionResponse } from './schemas';
export { apiClient, getAuthToken, setAuthToken, removeAuthToken } from './client';
export { categoriesApi } from './categories';
export { transactionsApi } from './transactions';
export { reportsApi } from './reports';
export { statementsApi } from './statements';
export { budgetsApi } from './budgets';

import { categoriesApi } from './categories';
import { transactionsApi } from './transactions';
import { reportsApi } from './reports';
import { statementsApi } from './statements';
import { budgetsApi } from './budgets';

export const api = {
  getCategories: categoriesApi.getAll,
  createCategory: categoriesApi.create,
  updateCategory: categoriesApi.update,
  getTransactions: transactionsApi.getAll,
  createTransaction: transactionsApi.create,
  batchCreateTransactions: transactionsApi.batchCreate,
  batchUpdateTransactions: transactionsApi.batchUpdate,
  updateTransaction: transactionsApi.update,
  deleteTransaction: transactionsApi.delete,
  getReport: reportsApi.get,
  previewStatement: statementsApi.preview,
  getBudgetGoals: budgetsApi.getGoals,
  updateBudgetGoals: budgetsApi.updateGoals,
  getBudgetSummary: budgetsApi.getSummary,
};
